export const blockIconsContentAddCircle = (
	<span className='material-symbols-outlined'>add_circle</span>
);
